import React from "react";
import Fragment from "react-dot-fragment";
import styled from "styled-components";
import Icon from '../../containers/assets/info-icon.png';
import Icon2 from '../../containers/assets/avatar-icon.png';

const AlertOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  opacity: 0.4;
  z-index: 1001;
`;

const AlertWrapper = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 600px;
  position: fixed;
  z-index: 1002;
  top: 200px;
  left: 50%;
  margin-left: -300px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

const AlertTitle = styled.div`
  padding: 16px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;

  font-family: 'Mukta Vaani';
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  border-bottom: 1px solid #f0f0f0;
`;

const AlertMessage = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
`;

const AlertButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
  border-top: 1px solid #f0f0f0;
  padding: 10px 24px;
  align-items: flex-start;
  justify-content: flex-end;
`;

const AlertButton = styled.div`
  background: #5c91f5;
  border: 1.5px solid #5c91f5;
  border-radius: 4px;
  color: #ffffff;
  display: block;
  padding: 6px 14px;
  cursor: pointer;

  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;

const AlertRow = styled.div`
  background: #ebf2ff;
  padding: 12px;
  border-radius: 4px;
  flex: 0 0 100%;
  width: 100%;

  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

const AlertRowBody = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
`;

const isShown = (show, title, message1, message2, message3, onClose) => {
  return (
    show === true &&
    title !== "" &&
    (
      (message1 !== "" && message1 !== null) ||
      (message2 !== "" && message2 !== null) ||
      (message3 !== "" && message3 !== null)
    ) &&
    onClose
  );
};

const closeAction = (e, onClose) => {
  e.preventDefault();

  onClose(e);
};

const CoachingFeedback = ({ team_color, onClose, title, message1, message2, message3, show }) =>
  isShown(show, title, message1, message2, message3, onClose) ? (
    <Fragment>
      <AlertOverlay />
      <AlertWrapper>
        <AlertTitle>
          <div><img src={Icon} alt="" /></div>
          <div>{title}</div>
        </AlertTitle>
        <AlertMessage>
          {message1 && (
            <AlertRow>
              <AlertRowBody>
                <div><img src={Icon2} alt="" /></div>
                <div>{message1}</div>
              </AlertRowBody>
            </AlertRow>
          )}
          {message2 && (
            <AlertRow>
              <AlertRowBody>
                <div><img src={Icon2} alt="" /></div>
                <div>{message2}</div>
              </AlertRowBody>
            </AlertRow>
          )}
          {message3 && (
            <AlertRow>
              <AlertRowBody>
                <div><img src={Icon2} alt="" /></div>
                <div>{message3}</div>
              </AlertRowBody>
            </AlertRow>
          )}
        </AlertMessage>
        <AlertButtons>
          <AlertButton onClick={e => closeAction(e, onClose)}>Ok, I got it</AlertButton>
        </AlertButtons>
      </AlertWrapper>
    </Fragment>
  ) : null;

export default CoachingFeedback;



// WEBPACK FOOTER //
// ./src/components/coaching-feedback/index.js